/**
 * InvoiceFilter Component
 *
 * Filter invoices by status and date range.
 */

import { useEffect, useState } from 'react'
import { MenuComponent } from '../../_metronic/assets/ts/components'
import { useQueryRequest } from './request'
import { useQueryResponse } from './response'
import { useSearchParams } from 'react-router-dom'

const InvoiceFilter = () => {
    const { updateState } = useQueryRequest()
    const { isLoading } = useQueryResponse()

    const [selectedStatus, setSelectedStatus] = useState('')
    const [selectedFromDate, setSelectedFromDate] = useState('')
    const [selectedToDate, setSelectedToDate] = useState('')

    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        MenuComponent.reinitialization()

        // Get filters from URL
        const statusParam = searchParams.get('status') || ''
        const fromDateParam = searchParams.get('from_date') || ''
        const toDateParam = searchParams.get('to_date') || ''

        setSelectedStatus(statusParam)
        setSelectedFromDate(fromDateParam)
        setSelectedToDate(toDateParam)

        if (statusParam || fromDateParam || toDateParam) {
            updateState({
                filter: {
                    ...(statusParam && { status: statusParam }),
                    ...(fromDateParam && { from_date: fromDateParam }),
                    ...(toDateParam && { to_date: toDateParam }),
                },
            })
        }
    }, [])

    const resetData = () => {
        setSelectedStatus('')
        setSelectedFromDate('')
        setSelectedToDate('')
        setSearchParams('')
        updateState({ filter: undefined })
    }

    const filterData = () => {
        const params = {}

        if (selectedStatus) params.status = selectedStatus
        if (selectedFromDate) params.from_date = selectedFromDate
        if (selectedToDate) params.to_date = selectedToDate

        setSearchParams(params)
        updateState({ filter: params })
    }

    const hasActiveFilters =
        selectedStatus !== '' ||
        selectedFromDate !== '' ||
        selectedToDate !== ''

    return (
        <div className='d-flex align-items-end flex-wrap gap-3'>

            {/* Status */}
            <div>
                <label className='form-label fs-7 fw-semibold text-gray-600 mb-1'>
                    Status
                </label>
                <select
                    className='form-select form-select-solid fw-semibold'
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    style={{ minWidth: '150px' }}
                >
                    <option value=''>All Status</option>
                    <option value='1'>Uploaded</option>
                    <option value='2'>Verified</option>
                    <option value='3'>In Progress</option>
                    <option value='4'>Duplicate</option>
                    <option value='5'>Rejected</option>
                    <option value='6'>Exception</option>
                    <option value='7'>AI Verified</option>
                    <option value='8'>Incomplete</option>
                </select>
            </div>

            {/* From Date */}
            <div>
                <label className='form-label fs-7 fw-semibold text-gray-600 mb-1'>
                    From Date
                </label>
                <input
                    type='date'
                    className='form-control form-control-solid'
                    value={selectedFromDate}
                    onChange={(e) => setSelectedFromDate(e.target.value)}
                    max={selectedToDate || undefined}
                />
            </div>

            {/* To Date */}
            <div>
                <label className='form-label fs-7 fw-semibold text-gray-600 mb-1'>
                    To Date
                </label>
                <input
                    type='date'
                    className='form-control form-control-solid'
                    value={selectedToDate}
                    onChange={(e) => setSelectedToDate(e.target.value)}
                    min={selectedFromDate || undefined}
                    disabled={!selectedFromDate}
                />
            </div>

            {/* Buttons */}
            <div className='ms-auto d-flex gap-2'>
                <button
                    type='button'
                    onClick={filterData}
                    className='btn btn-primary fw-semibold px-4'
                    data-kt-menu-dismiss='true'
                >
                    Apply
                </button>

                {hasActiveFilters && (
                    <button
                        type='button'
                        disabled={isLoading}
                        onClick={resetData}
                        className='btn btn-light btn-light-primary fw-semibold px-4'
                        data-kt-menu-dismiss='true'
                    >
                        Reset
                    </button>
                )}
            </div>

        </div>
    )
}

export { InvoiceFilter }